
import { TableOfContentsItem } from "@/components/blog/TableOfContents";

export const seoInteligenteTableOfContents: TableOfContentsItem[] = [
  {
    id: "impacto-ia-seo",
    title: "Impacto de la Inteligencia Artificial en el SEO",
    subItems: [
      { id: "transformacion-seo", title: "Transformación del SEO con IA" },
      { id: "beneficios-posicionamiento", title: "Beneficios de la IA en el Posicionamiento Web" }
    ]
  },
  {
    id: "herramientas-ia",
    title: "Herramientas de Inteligencia Artificial para SEO",
    subItems: [
      { id: "uso-chatgpt", title: "Uso de Herramientas de IA como ChatGPT" },
      { id: "tecnologias-analisis", title: "Tecnologías de Análisis de Datos" }
    ]
  },
  {
    id: "palabras-clave",
    title: "Búsqueda de Palabras Clave y Optimización de Contenido",
    subItems: [
      { id: "investigacion-keywords", title: "Investigación de Palabras Clave Inteligente" },
      { id: "contenido-automatizado", title: "Creación y Generación de Contenido Automatizado" }
    ]
  },
  {
    id: "estrategias-optimizacion",
    title: "Estrategias para Optimizar el Contenido",
    subItems: [
      { id: "densidad-keywords", title: "Densidad de Palabras Clave Óptima" },
      { id: "contenido-calidad", title: "Generar Contenido de Alta Calidad" }
    ]
  },
  {
    id: "experiencia-usuario",
    title: "Inteligencia Artificial para Mejorar la Experiencia del Usuario",
    subItems: [
      { id: "personalizacion", title: "Personalización del Contenido mediante IA" },
      { id: "velocidad-carga", title: "IA en la Optimización de la Velocidad de Carga" },
      { id: "seo-local", title: "SEO Local y Orientación Geográfica" }
    ]
  },
  {
    id: "analisis-resultados",
    title: "Competencia y Análisis de Resultados",
    subItems: [
      { id: "analisis-competencia", title: "Análisis de Competencia con IA" },
      { id: "monitoreo-trafico", title: "Uso de IA para Monitorear el Tráfico" }
    ]
  },
  {
    id: "tendencias-futuras",
    title: "Futuras Tendencias del SEO Impulsadas por la IA",
    subItems: [
      { id: "contenido-usuarios", title: "Contenido Generado por Usuarios" },
      { id: "auditorias-automatizadas", title: "SEO Técnico y Auditorías" },
      { id: "preparacion-futuro", title: "Preparación para el Futuro del SEO" }
    ]
  }
];
